import { useEffect, useState } from 'react';
import { customFarms } from '../../../requests/api/apiClient';

interface FarmsCounterState {
  dbCount: number | null;
  wiseconnCount: number | null;
  loading: boolean;
  wiseconnError: boolean;
}

const useWiseconnFarmsCount = (): FarmsCounterState => {
  const [state, setState] = useState<FarmsCounterState>({
    dbCount: null,
    wiseconnCount: null,
    loading: true,
    wiseconnError: false,
  });

  useEffect(() => {
    let cancelled = false;

    const fetchCounts = async () => {
      const [dbRes, wiseconnRes] = await Promise.allSettled([
        customFarms.listWithCounts({ page: 0, limit: 1 }),
        customFarms.wiseconnCount(),
      ]);

      if (cancelled) return;

      const dbCount = dbRes.status === 'fulfilled'
        ? dbRes.value.data?.totalFarms ?? 0
        : null;

      const wiseconnCount = wiseconnRes.status === 'fulfilled'
        ? wiseconnRes.value.data?.count ?? 0
        : null;

      setState({
        dbCount,
        wiseconnCount,
        loading: false,
        wiseconnError: wiseconnRes.status === 'rejected',
      });
    };

    fetchCounts();

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
};

export default useWiseconnFarmsCount;
